// src/pages/History/MedievalHistory/MongolEmpireGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import bg from '../../../assets/history/Middle_Ages_-_Mongol_Empire.png';
import { BugOffIcon } from 'lucide-react';

function HistoryPageMongolsGo() {
  return (
    <QuizPage
      title="History: Mongol Empire"
      subTopic="Mongol Empire"
      backgroundImage={bg}
      returnPath="/History-Mongol-Empire"
    />
  );
}

export default HistoryPageMongolsGo;   